import { ArchivedTaskDataDto } from "./ArchiveTasksDto";
import { ArchivedTaskDataModel } from "./ArchiveTasksModel";

export const transformArchiveTasksDtoToModel = (
  dto: ArchivedTaskDataDto
): ArchivedTaskDataModel => dto;
